module.exports = __webpack_public_path__ + "static/media/figure-1a.d7b74176.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/faq/change-batteries/figure-1a.jpg
// module id = 1204
// module chunks = 0